var map = {
	"./batching/feature": [
		70832,
		9423,
		5208,
		7943,
		1526,
		3162,
		7012,
		1658,
		6609,
		8596,
		9200,
		3961,
		656,
		8920,
		3380
	],
	"./counterfactual/feature": [
		46528,
		5208,
		9423,
		3162,
		8174,
		7012,
		9115,
		9200,
		3961,
		7320,
		8321,
		7354,
		1226,
		8201,
		5705,
		8211
	],
	"./hypernative/feature": [
		59275,
		9596,
		8321,
		8477
	],
	"./ledger/feature": [
		61681,
		5208,
		1681
	],
	"./myAccounts/feature": [
		9832,
		3162,
		5702,
		8596,
		9407,
		9832
	],
	"./nfts/feature": [
		35369,
		6660,
		5208,
		9484,
		3265,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		7943,
		1065
	],
	"./portfolio/feature": [
		92050,
		5815,
		2050
	],
	"./recovery/feature": [
		3837,
		7943,
		1526,
		5208,
		9423,
		3162,
		7012,
		1658,
		6609,
		9115,
		7848,
		4293,
		1276,
		8596,
		9200,
		3961,
		656,
		8920,
		7320,
		6205,
		8391,
		3985
	],
	"./spaces/feature": [
		30772,
		6733,
		3162,
		5208,
		7943,
		5420,
		8596,
		772
	],
	"./speedup/feature": [
		77363,
		5208,
		9423,
		9200,
		7363
	],
	"./spending-limits/feature": [
		21883,
		5208,
		3483,
		3162,
		9423,
		7943,
		1526,
		8174,
		7012,
		1658,
		6609,
		9115,
		7848,
		4293,
		1276,
		9701,
		5420,
		8596,
		9200,
		3961,
		656,
		8920,
		7320,
		8321,
		7354,
		1226,
		8201,
		6205,
		8391,
		6259,
		7831,
		1883
	],
	"./stake/feature": [
		77754,
		7943,
		1526,
		5208,
		9423,
		3162,
		7012,
		1658,
		6609,
		8596,
		9200,
		3961,
		656,
		8920,
		5839
	],
	"./swap/feature": [
		21221,
		1526,
		2148,
		1221
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		31429,
		3790,
		1429
	],
	"./tx-notes/feature": [
		73322,
		3322
	],
	"./walletconnect/feature": [
		4390,
		1520,
		7943,
		7012,
		1658,
		6609,
		6847,
		5382,
		4390
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;